require("@babel/polyfill");
// Load css
require("../scss/main.scss");
let PageLoaded = require("./components/PageLoaded");
let Footer = require("./partials/Footer");

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('append')) {
            return;
        }
        Object.defineProperty(item, 'append', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function append() {
                var argArr  = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.appendChild(docFrag);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);


new PageLoaded().wait(() => {
    let modules = document.getElementsByTagName('main')[0].getAttribute('data-modules');

    if (modules !== '') {
        modules = modules.split('|');

        for (let mod of modules) {
            mod = mod.charAt(0).toUpperCase() + mod.slice(1);

            let currentModule = require('./pages/' + mod + '.js');
            new currentModule();
        }
    }

    new Footer();

});